import { types } from "mobx-state-tree"
import { FinanceTransactionSearch } from "./FinanceTransactionSearch";

export const FeeTransactionSearch = types.compose(
    'FeeTransactionSearch',
    FinanceTransactionSearch,
    types.model({
        fee_type_id: "",
    })
)